import { createSSDPClient } from '@/utils/ssdp'
import { createApplication } from '@/utils/host_application';
import { account } from '@/utils/account';
import { createCloudMqtt } from '@/utils/cloud_mqtt';
import { CreateDownloader } from '@/utils/downloader';
/*
 * @Author: zuoxuecheng
 * @Date: 2024-07-08 11:12:22
 * @Description: 添加打印机调用切片软件接口
 */
let ssdpclient = createSSDPClient();
let app = createApplication();
let cloudMqtt = new Map()

function setCloudMqtt(objectName, obj) {
  cloudMqtt.set(objectName, obj)
}
function getCloudMqtt(objectName) {
  return cloudMqtt.get(objectName)
}

function destoryMqtt(identity) {
  cloudMqtt.forEach((value, key) => {
    if (value.get_identity() == identity) {
      value.destroy()
      cloudMqtt.delete(key)
      return 0
    }
  })
  return 0;
}

// 设备发现回调
export async function device_notify(callback) {
  return await ssdpclient.device_notify(callback)
}

// 设备发现
export async function search_device(type, times, time) {
  return await ssdpclient.search_device(type, times, time)
}

/**
 * @description:mqtt对象创建
 * @param {*} identity 唯一ID
 * @param {*} objectName 名字
 * @param {*} mode 1-局域网模式，2-公网模式
 */
export async function createMqtt(identity, objectName, mode) {
  let obj = await createCloudMqtt(identity, objectName, mode)
  if (obj) {
    setCloudMqtt(objectName, obj)
    return 0
  }
  return -1
}

// mqtt对象销毁
export function destroyMqtt(identity) {
  return destoryMqtt(identity);

}

/**
* @describe 连接mqtt服务器
* 
* @param mode 连接模型：1-局域网模式，2-公网模式
* @param host 服务器地址
* @param port 服务器端口 --默认1883走TCP协议，8883走SSL协议
* @param device_type 设备类型:lcd;fdm
* @param username 用户名 公网模型下忽略
* @param password 密码 公网模型下忽略
* @param Certificate 根证书
* @param PrivateKey 客户端证收私钥
* @param KeyStore 客户端证书
* 
* @returns 成功返回0,失败返回错误代码
*/
export function connect(objectName, { mode, host, port, device_type, username, password, Certificate, PrivateKey, KeyStore, clientId }) {
  return getCloudMqtt(objectName)?.connect(
    mode ? mode : 0,
    host ? host : '0',
    port ? port : 0,
    device_type ? device_type : '0',
    username ? username : '0',
    password ? password : '0',
    clientId ? clientId : '0',
    Certificate ? Certificate : '0',
    PrivateKey ? PrivateKey : '0',
    KeyStore ? KeyStore : '0'
  )
}

/**
* @describe 订阅主题
* 
* @param topic 主题名称
* @returns 成功返回0,失败返回错误代码
*/
export function subscribe(objectName, topic) {
  return getCloudMqtt(objectName)?.subscribe(topic);
}
// 订阅打印机所有
export function subscribe_printer(objectName, model_id, devicer_id) {
  return getCloudMqtt(objectName)?.subscribe_printer(model_id, devicer_id);
}

/**
* @describe 取消订阅主题
* 
* @param topic 主题名称
* @returns 成功返回0,失败返回错误代码
*/
export function unsubscribe(objectName, topic) {
  return getCloudMqtt(objectName)?.unsubscribe(topic);
}

/**
* @describe 发布消息
* 
* @param topic 主题名称
* @param payload 载荷
* @returns 成功返回0,失败返回错误代码
*/
export function publish(objectName, topic, payload) {
  return getCloudMqtt(objectName)?.publish(topic, payload);
}

/**
* @describe 断开连接
* 
* @returns 成功返回0,失败返回错误代码
*/
export function disconnect(objectName) {
  return getCloudMqtt(objectName)?.disconnect();
}

/**
* @describe 注册消息接收回调
* 
* @param callback 回调函数
* @returns 成功返回0,失败返回错误代码
*/
export function set_recv(objectName, callback) {
  return getCloudMqtt(objectName)?.set_recv(callback)
}

// 是否连接成功
export async function isConnect(objectName) {
  return await getCloudMqtt(objectName)?.is_connected();
}

// 连接状态回调
export function stateCallback(objectName, callback) {
  return getCloudMqtt(objectName)?.event_call(callback);
}

/**
 * @brief 显示toast提示
 * 
 * @param type 类型
 * @param title 标题
 * @param message 内容
 * @param msg_type 内容类型 1： TEXT 2：HTML -- 2024-08-06 新增
 * @param id 唯一标识，用于标记当次调用 -- 2024-08-15 新增
 * @param btns 按钮组合 -- 2024-09-29 新增
 * @returns 成功返回0,失败返回错误代码
 */
export function showBox(type, title, message, msg_type, id, btns) {
  return app.show_box(type, title, message, msg_type, id, btns)
}

/**
* @describe 注册消息接收回调
* 
* @param callback 回调函数
* @returns 成功返回0,失败返回错误代码
*/
export function set_show_notify(callback) {
  return app.set_show_notify(callback)
}


/**
 * @describe 订阅打印机-不用于局域网
 *
 * @param model_id 型号ID
 * @param devicer_id 设备ID
 * @returns 成功返回0,失败返回错误代码
 * @note 支持自动重订阅
 */
export let subscribePrinter = (objectName, model_id, devicer_id) => {
  return getCloudMqtt(objectName)?.subscribe_printer(model_id, devicer_id)
}

/**
 * @describe 取消订阅打印机-不用于局域网
 *
 * @param devicer_id 设备ID
 * @returns 成功返回0,失败返回错误代码
 */
export let unsubscribePrinter = (objectName, devicer_id) => {
  return getCloudMqtt(objectName)?.unsubscribe_printer(devicer_id)
}

/**
 * @describe 获取用户信息json
 *
 * @param type 1:获取login_token,2:获取access_token
 * @returns 成功返回josn
 */
export let userToken = (type) => {
  return account.user_token(type)
}

/**
* @describe 导入模型文件
* 
* @param file_path 用户模型
* @param import_type 导入类型
* @returns 成功返回0,失败返回错误代码
*/
// enum ImportType {
//   User = 0,      ///< 用户自定
//   ModelOnly = 1, ///< 只导入模型
//   Project = 2,   ///< 打开整个项目
// }
export let importModel = (file_path, import_type) => {
  return app.import_model(file_path, import_type)
}

/**
* @describe 打开模型文件目录
* 
* @param file_path 用户模型文件名 ,为空则打开模型目录
* @returns 成功返回0,失败返回错误代码
*/
export let openModelDir = (file_path) => {
  return app.open_model_dir(file_path)
}


const downloader = CreateDownloader();

/**
* @describe 判断文件存在
* 
* @param file_path 文件路径(一般仅为文件名)
* @returns {number} 0表示不存在，其他为存在
*/
export let existsFile = (file_path) => {
  return downloader.exists_file(file_path)
}

/**
* @describe 计算md5值
* 
* @param file_path 文件路径(一般仅为文件名)
* @param fast 快速度算法启用；1启用，0不启用
*/
export let fileMd5 = (file_path, fast) => {
  return downloader.file_md5(file_path, fast)
}

/**
* @describe 设置下载完成通知回调
* 
* @param fuction 回调
*/
export let setNotify = (fuction) => {
  /**
   * @describe 订阅消息接收回调
   * 
   * @param url 下载地址
   * @param orgin_md5 文件原始md5值
   * @param fast_md5 文件快速md5值
   */
  return downloader.set_notify(fuction)
}

/**
 * @describe 移动文件
 * 
 * @param dst_path 目标文件路径-- 如果目标目录不存在，则自动创建
 * @param src_path 源文件路径
 * @returns 成功返回0,失败返回错误代码
 */
export let moveFile = (dst_path, src_path) => {
  return downloader.move_file(dst_path, src_path)
}

/**
 * @brief 配置保存
 * 
 * @param key 配置项名称 (eg:key1.key2.key3)
 * @param value 配置项值
 * @returns 成功返回0,失败返回错误代码
 */
export let configWrite = (key, value) => {
  return app.config_write(key, value)
}

/**
 * @brief 配置读取
 * 
 * @param key 配置项名称 (eg:key1.key2.key3)
 * @returns 配置项值
 */
export let configRead = (key) => {
  return app.config_read(key)
}
/**
 * @brief 软件跳转工作台处理
 * 
 * @param key 配置项名称 (eg:number.str1.str2)
 * @returns 配置项值
 */
export let common_notify = () => {
  return app.common_notify()
}

